import { render, staticRenderFns } from "./create-town.vue?vue&type=template&id=3e4f7472&scoped=true&"
import script from "./create-town.vue?vue&type=script&lang=js&"
export * from "./create-town.vue?vue&type=script&lang=js&"
import style0 from "./create-town.vue?vue&type=style&index=0&id=3e4f7472&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e4f7472",
  null
  
)

export default component.exports